<template>
    <div>
        <div class="page-top mb-1 mb-3">
            <h1> Add Fee Company </h1>
        </div>
        <div class="global-main">
            <form id="companyForm" @submit.prevent="addFeeCompanyData">
                <div class="tab-content-inner">
                    <div class="form-group">
                        <label>Payment Engine <em class="required">*</em></label>
                        <select v-model="form.payment_engine" name="payment_engine" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('payment_engine') }">
                            <option value="" selected>Select Payment Engine</option>
                            <option value="MEEZAN">Meezan Bank</option>
                            <option value="FINCA">Finca Microfinance Bank</option>
                        </select>
                        <has-error :form="form" field="payment_engine"></has-error>
                    </div>
                    <div class="form-group">
                        <label>Fee Type <em class="required">*</em></label>
                        <select v-model="form.fee_type" name="fee_type" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('fee_type') }">
                            <option value="" selected>Select Fee Type</option>
                            <option value="VOUCHER">Voucher ID</option>
                            <option value="CONSUMER">Consumer ID</option>
                        </select>
                        <has-error :form="form" field="fee_type"></has-error>
                    </div>
                    <div class="form-group">
                        <label>Identifier System <em class="required">*</em></label>
                        <select v-model="form.identifier_system" name="identifier_system" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('identifier_system') }">
                            <option value="" selected>Select Identifier System</option>
                            <option value="FINPAY">Finpay</option>
                            <option value="EXTERNAL">External</option>
                        </select>
                        <has-error :form="form" field="identifier_system"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Name <em class="required">*</em></label>
                        <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                        <has-error :form="form" field="name"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Email <em class="required">*</em></label>
                        <input v-model="form.email" type="email" name="email" class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                        <has-error :form="form" field="email"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Password </label>
                        <input v-model="form.password" type="password" name="password" class="form-control" :class="{ 'is-invalid': form.errors.has('password') }">
                        <has-error :form="form" field="password"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Phone <em class="required">*</em></label>
                        <input v-model="form.phone" @keypress="onlyNumber" type="number" name="phone" class="form-control" :class="{ 'is-invalid': form.errors.has('phone') }">
                        <has-error :form="form" field="phone"></has-error>
                    </div>
                    <div class="form-group">
                        <label> WalletID <em class="required">*</em></label>
                        <input v-model="form.walletID" @keypress="onlyNumber" type="number" name="walletID" class="form-control" :class="{ 'is-invalid': form.errors.has('walletID') }">
                        <has-error :form="form" field="walletID"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Address 1 <em class="required">*</em></label>
                        <textarea v-model="form.address_1" name="address_1" class="form-control" :class="{ 'is-invalid': form.errors.has('address_1') }"></textarea>
                        <has-error :form="form" field="address_1"></has-error>
                    </div>
                    <div class="form-group">
                        <label> City <em class="required">*</em></label>
                        <select v-model="form.city_id" name="city_id" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('city_id') }" v-if="cities != null">
                            <option value="" selected>Select City</option>
                            <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id">
                                {{ city.name }}
                            </option>
                        </select>
                        <has-error :form="form" field="city_id"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Fee Code </label>
                        <input v-model="form.fee_code" type="text" name="fee_code" class="form-control" :class="{ 'is-invalid': form.errors.has('fee_code') }" readonly>
                        <has-error :form="form" field="fee_code"></has-error>
                    </div>
                </div>
                <div class="form-group">
                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                    <router-link to="/companies" class="btn btn-primary float-right mr-2">Cancel</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    payment_engine : '',
                    fee_type : '',
                    identifier_system : '',
                    name : '',
                    email : '',
                    password : '',
                    phone : '',
                    walledID : '',
                    address_1 : '',
                    city_id : '',
                    fee_code : '',
                }),
                cities: null
            }
        },
        methods: {
            addFeeCompanyData() {
                this.$Progress.start();
                this.form.post('api/addFeeCompany')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('succes','Fee company created successfully');
                        this.$router.push('/feeCompanies');
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in you form data');
                    $('.selectpicker').selectpicker('refresh');
                });
            },
            getAddFeeCompanyData(){
                this.$Progress.start();
                axios.get('/api/addFeeCompanyData')
                .then(res => {
                    if(res.status == 200){
                        this.cities = res.data.cities;
                        this.form.fee_code = res.data.fee_code;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                }).then(res => {
                    $('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            },
        },
        created() {
            this.getAddFeeCompanyData();
        },
    }
</script>
